<template>
  <div
  v-on:click="onTouchScreen" ontouchstart=""
  class="prompt-touch-to-proceed">

    <div class="prompt-instruction">
      <div class="text-wrapper">
        <div style="align-items: center;display: flex;flex-direction: column;justify-content: center;flex:1">
          <img class="dealer-logo" v-if="requesteeInfo.dealer_logo_url" :src="requesteeInfo.dealer_logo_url" @error="defaultImg"/>
          <img class="dealer-logo" v-if="!requesteeInfo.dealer_logo_url" src="/static/img/icons/CHeKT_logo.png" @error="defaultImg"/>
          <div style="color:hsla(0,0%,100%,0.6)">
            <span v-if="requesteeInfo.dealer_company_name">{{requesteeInfo.dealer_company_name}}<br> needs you to verify this alarm.</span>
          </div>
        </div>
        <div style="flex:1;display: flex;flex-direction: column;justify-content: center;">
          <div style="padding:30px; 0px;line-height: 1.25;">
            <span class="focusing blink">Touch screen<br>to verify alarm.</span>
          </div>
          <div style="color:hsla(0,0%,100%,0.6)">
            <div style="padding-bottom: 10px;">
              <span
              v-if="contactName"
              style="font-weight: bold;">{{contactName + '!'}}</span>
            </div>
            <div>
              <span style="font-weight: bold;">Please verify the alarm ASAP!</span>
            </div>
            <div style="line-height: 1.25;">
              <span>Your monitoring station is<br>waiting for your response!</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'prompt-touch-to-proceed',
  components: {
    CompIcon
  },
  computed: {
    idToken: function () {
      return this.$store.getters.idToken
    },
    requesteeName: function () {
      return this.requesteeInfo.firstName && this.requesteeInfo.lastName ? this.requesteeInfo.firstName + ' ' + this.requesteeInfo.lastName : null
    },
    contactName: function () {
      let name = this.requesteeInfo.contactName
      if (!name) {
        name = this.requesteeName
      }
      return name
    }
  },
  data: function () {
    return {
      requesteeInfo: {
        contactId: null,
        slotNumber: null,
        phone: null,
        email: null,
        lastName: null,
        firstName: null,
        dealer_logo_url: null,
        dealer_company_name: null,
        contactName: null
      }
    }
  },
  watch: {
    idToken: function () {
      this.checkIdToken()
    }
  },
  created: function () {
    this.checkIdToken()
  },
  methods: {
    onTouchScreen: function () {
      this.$emit('onTouchScreen', null)
    },
    checkIdToken: function () {
      this.$logger.info('checkIdToken')
      if (this.idToken) {
        this.updateInfoDataFromIdToken()
      }
    },
    updateInfoDataFromIdToken: function () {
      this.$logger.info('updateInfoDataFromIdToken')
      if (this.idToken) {
        let object = this.$tool.decodeJwtToken(this.idToken)
        // requesteeInfo
        if ('phone' in object) {
          this.requesteeInfo.phone = object['phone']
        }
        if ('dealer_logo_url' in object) {
          this.requesteeInfo.dealer_logo_url = object['dealer_logo_url']
        }
        if ('dealer_company_name' in object) {
          this.requesteeInfo.dealer_company_name = object['dealer_company_name']
        }
        if ('contact_id' in object) {
          this.requesteeInfo.contactId = object['contact_id']
        }
        if ('slot_number' in object) {
          this.requesteeInfo.slotNumber = object['slot_number']
        }
        if ('email' in object) {
          this.requesteeInfo.email = object['email']
        }
        if ('firstname' in object) {
          this.requesteeInfo.firstName = object['firstname']
        } else {
          this.requesteeInfo.firstName = object['name']
        }
        if ('lastname' in object) {
          this.requesteeInfo.lastName = object['lastname']
        }
        if ('contact_name' in object) {
          this.requesteeInfo.contactName = object['contact_name']
        }
      }
    },
    defaultImg: function (e) {
      e.target.src = '/static/img/icons/CHeKT_logo.png'
    },
    getDealerLogo: function () {
      let dealerLogo = ''
      const idToken = this.$token.getIdTokenFromQuery()
      if (this.$token.hasValidToken()) {
        this.$store.commit('UPDATE_IDTOKEN', {
          idToken: idToken
        })
        if (idToken) {
          let object = this.$tool.decodeJwtToken(idToken)
          if ('dealer_logo_url' in object) {
            this.$store.commit('UPDATE_DEALER_LOGO', {
              dealerLogo: object['dealer_logo_url']
            })
            this.dealerLogo = object['dealer_logo_url']
            dealerLogo = object['dealer_logo_url']
          }
        }
      }
      return dealerLogo
    }
  },
  metaInfo () {
    return {
      meta: [
        {property: 'og:image', content: this.getDealerLogo()}
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.prompt-touch-to-proceed {
  /* common */
  background-color: hsla(0, 0%, 10%, 1);
  color: #fff;
  /* mouse */
  cursor: pointer;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  .prompt-text {
    /* common */
    font-size: 1.5em;
    /* size */
    padding: 1em;
    width: calc(100% - 2em);
    height: calc(100% - 3em - 2em);
    /* position */
    position: absolute;
    top: 0;
    left: 0;
    /* alignment */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .prompt-instruction {
    /* common */
    /* background-color: #fff; */
    background-color: hsla(0, 0%, 10%, 1);
    color: #fff;
    font-size: 1em;
    /* text */
    font-weight: bold;
    /* size */
    padding: 1em;
    width: 100%;
    height: 100%;
    /* position */
    position: absolute;
    bottom: 0;
    left: 0;
    /* alignment */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
  .prompt-instruction .focusing {
    /* common */
    font-size: 2em;
  }
  .blink {
    /* animation */
    animation-name: blinking;
    animation-duration: 1s;
    animation-iteration-count: infinite;
  }
}
.dealer-logo {
  max-width: 70%;
  max-height: 12.5em;
  min-width: 70%;
  min-height: 12.5em;
  padding-bottom:10px;
  object-fit: contain;
  &img:before {
    content: ' ';
    display: block;
    position: absolute;
    height: 50px;
    width: 50px;
    background-image: url('/static/img/icons/CHeKT_logo.png');
  }
}


@keyframes blinking {
  0%   {opacity: 0;}
  50%  {opacity: 1;}
  100% {opacity: 0;}
}

@media screen and (orientation: portrait) {
  .prompt-touch-to-proceed {
    .prompt-instruction{
      .text-wrapper {
        flex-direction: column;
      }
    }
  }
}

/* For landscape, we want the tool bar stick on the left */

@media screen and (orientation: landscape) {
  .prompt-touch-to-proceed {
    .prompt-instruction{
      .text-wrapper {
        flex-direction: row;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Verification/PromptTouchToProceed.vue